const viteEnv = typeof import.meta !== "undefined" && typeof import.meta.env !== "undefined"
  ? import.meta.env
  : undefined;

const DEFAULT_APP_URL = "https://demo.rugira.ch";

function normalizeBaseUrl(value?: string) {
  if (!value) {
    return DEFAULT_APP_URL;
  }

  return value.replace(/\/+$/, "");
}

export function getAppBaseUrl() {
  return normalizeBaseUrl(viteEnv?.VITE_APP_URL || DEFAULT_APP_URL);
}

export function getAppUrl(path = "") {
  return `${getAppBaseUrl()}${path}`;
}

export function getLaunchUrl() {
  return getAppUrl("/login?next=/overview");
}
